import { CheckCircle, ArrowRight } from "lucide-react";

export const ReplyDeliverabilityTakeaway = () => {
  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-success/5 via-success/10 to-success/5 border border-success/20 rounded-2xl p-5 sm:p-6">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-24 bg-success/10 blur-3xl" />
      
      <div className="relative flex items-start gap-4">
        <div className="shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-success/15 flex items-center justify-center">
          <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-success" />
        </div>
        <div className="flex-1">
          <h2 className="font-display text-lg sm:text-xl font-semibold text-foreground mb-2">
            Key Takeaway
          </h2>
          <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
            In 2026, ISPs use <span className="font-semibold text-foreground">reply signals as the primary indicator</span> of sender quality. 
            Open rates—plagued by bot clicks and Apple MPP—are no longer reliable. To maximize deliverability, 
            optimize for replies: ask questions, write conversationally, and measure engagement by responses, not opens.
          </p>
          <div className="flex items-center gap-2 mt-3 text-sm text-success font-medium">
            <ArrowRight className="w-4 h-4" />
            <span>Learn how to transition your email strategy below</span>
          </div>
        </div>
      </div>
    </div>
  );
};